import fs from 'fs'

export function getAllSubFolders(folderPath: string) {
	return fs
		.readdirSync(folderPath, { withFileTypes: true })
		.filter((dirent) => dirent.isDirectory())
		.map((dirent) => dirent.name)
}
